/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { registerLanguage } from '../_.contribution.js';
registerLanguage({
  id: 'go',
  extensions: ['.go'],
  aliases: ['Go'],
  loader: function () {
    return import('./go.js');
  }
});